export class Book {
  /**
   *
   */
  $key: string;
  bookName: string;
  version: number;
}
